import { cn } from '@/lib/utils'

interface ChonkyButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'destructive'
  size?: 'default' | 'sm' | 'icon'
  loading?: boolean
}

export function ChonkyButton({
  children,
  variant = 'primary',
  size = 'default',
  className,
  disabled,
  loading,
  ...props
}: ChonkyButtonProps) {
  return (
    <button
      className={cn(
        'btn-chonky',
        `btn-chonky-${variant}`,
        size === 'sm' && 'btn-chonky-sm',
        size === 'icon' && 'btn-chonky-icon',
        (disabled || loading) && 'opacity-50 pointer-events-none',
        className
      )}
      disabled={disabled || loading}
      {...props}
    >
      <span className="btn-edge" />
      <span className="btn-surface">{children}</span>
    </button>
  )
}
